package com.havn.app.ui.theme

import com.havn.app.features.agency.domain.HavnSubscriptionTier
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

class HavnThemeManager(
    initialTheme: HavnThemeType = loadStoredHavnThemeType()
) {
    private val _themeType = MutableStateFlow(initialTheme)
    val themeType: StateFlow<HavnThemeType> = _themeType.asStateFlow()

    fun setTheme(type: HavnThemeType, canUsePremiumThemes: Boolean): Boolean {
        if (!canUsePremiumThemes && type != HavnThemeType.OBSIDIAN_GOLD) {
            return false
        }
        _themeType.value = type
        storeHavnThemeType(type)
        return true
    }
}

fun canUsePremiumThemes(tier: HavnSubscriptionTier): Boolean =
    tier == HavnSubscriptionTier.ProAgent
